module.exports = __webpack_public_path__ + "img/ks-Safety-Net-Kewangan.c2a8eeb8.jpeg";